<template>
  <div class="min-h-screen bg-gray-50 font-body">
    <!-- Header -->
    <header class="bg-white shadow-sm border-b border-gray-200">
      <div class="container mx-auto px-4 py-4">
        <div class="flex items-center justify-between flex-col md:flex-row gap-3">
          <div class="flex items-center space-x-4 space-x-reverse">
            <div class="relative">
                             <img
                 src="@/assets/Logo.png"
                 alt="کبابی مارو"
                 class="navbar-logo w-12 h-12"
               />
            </div>
            <div>
              <h1 class="text-xl font-semibold text-gray-800">گزارشات سفارشات</h1>
              <p class="text-sm text-gray-500">کبابی مارو</p>
            </div>
          </div>

          <div class="flex items-center space-x-3 space-x-reverse flex-wrap justify-center md:justify-end">
            <button
              @click="goToAdminPanel"
              class="bg-gray-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-700 transition-colors"
            >
              بازگشت به پنل
            </button>
            <button
              @click="goToMenu"
              class="bg-brown-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-brown-700 transition-colors"
            >
              مشاهده منو
            </button>
          </div>
        </div>
      </div>
    </header>

    <!-- Main Content -->
    <main class="container mx-auto px-4 py-8">
      <!-- Date Range Filter -->
      <div class="bg-white p-6 rounded-lg shadow-md mb-6">
        <h2 class="text-lg font-semibold text-gray-800 mb-4">فیلتر تاریخ</h2>
        <div class="flex items-center space-x-4 space-x-reverse">
                     <div>
             <label class="block text-sm font-medium text-gray-700 mb-1">از تاریخ</label>
             <input
               v-model="dateFrom"
               type="text"
               readonly
               placeholder="انتخاب تاریخ"
               class="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brown-500 focus:border-transparent w-full cursor-pointer"
               @click="openDatePicker('from')"
             />
           </div>
           <div>
             <label class="block text-sm font-medium text-gray-700 mb-1">تا تاریخ</label>
             <input
               v-model="dateTo"
               type="text"
               readonly
               placeholder="انتخاب تاریخ"
               class="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brown-500 focus:border-transparent w-full cursor-pointer"
               @click="openDatePicker('to')"
             />
           </div>
          <div class="flex items-end">
            <button
              @click="loadReports"
              :disabled="loading"
              class="bg-brown-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-brown-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <span v-if="loading">در حال بارگذاری...</span>
              <span v-else>اعمال فیلتر</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Statistics Cards -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <div class="bg-white p-6 rounded-lg shadow-md">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-blue-100 text-blue-600">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
              </svg>
            </div>
            <div class="mr-4">
              <p class="text-sm font-medium text-gray-600">کل سفارشات</p>
              <p class="text-2xl font-bold text-gray-900">{{ statistics.totalOrders }}</p>
            </div>
          </div>
        </div>

        <div class="bg-white p-6 rounded-lg shadow-md">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-green-100 text-green-600">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <div class="mr-4">
              <p class="text-sm font-medium text-gray-600">سفارشات تکمیل شده</p>
              <p class="text-2xl font-bold text-gray-900">{{ statistics.completedOrders }}</p>
            </div>
          </div>
        </div>

        <div class="bg-white p-6 rounded-lg shadow-md">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-red-100 text-red-600">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </div>
            <div class="mr-4">
              <p class="text-sm font-medium text-gray-600">سفارشات لغو شده</p>
              <p class="text-2xl font-bold text-gray-900">{{ statistics.cancelledOrders }}</p>
            </div>
          </div>
        </div>

        <div class="bg-white p-6 rounded-lg shadow-md">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-yellow-100 text-yellow-600">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"></path>
              </svg>
            </div>
            <div class="mr-4">
              <p class="text-sm font-medium text-gray-600">مجموع درآمد</p>
              <p class="text-2xl font-bold text-gray-900">{{ formatPrice(statistics.totalRevenue) }}</p>
            </div>
          </div>
        </div>

        <div class="bg-white p-6 rounded-lg shadow-md">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-blue-100 text-blue-600">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"></path>
              </svg>
            </div>
            <div class="mr-4">
              <p class="text-sm font-medium text-gray-600">سفارشات تحویل</p>
              <p class="text-2xl font-bold text-gray-900">{{ statistics.pickupOrders }}</p>
            </div>
          </div>
        </div>

        <div class="bg-white p-6 rounded-lg shadow-md">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-purple-100 text-purple-600">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
              </svg>
            </div>
            <div class="mr-4">
              <p class="text-sm font-medium text-gray-600">سفارشات داخلی</p>
              <p class="text-2xl font-bold text-gray-900">{{ statistics.internalOrders }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Section Statistics -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
        <!-- Orders by Section -->
        <div class="bg-white p-6 rounded-lg shadow-md">
          <h3 class="text-lg font-semibold text-gray-800 mb-4">سفارشات بر اساس بخش</h3>
          <div class="space-y-3">
            <div
              v-for="section in sectionStats"
              :key="section.sectionName"
              class="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
            >
              <span class="font-medium text-gray-700">{{ section.sectionName }}</span>
              <div class="flex items-center space-x-2 space-x-reverse">
                <span class="text-sm text-gray-500">{{ section.orderCount }} سفارش</span>
                <span class="text-sm font-medium text-brown-600">{{ formatPrice(section.totalRevenue) }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Orders by Status -->
        <div class="bg-white p-6 rounded-lg shadow-md">
          <h3 class="text-lg font-semibold text-gray-800 mb-4">سفارشات بر اساس وضعیت</h3>
          <div class="space-y-3">
            <div class="flex items-center justify-between p-3 bg-green-50 rounded-lg">
              <span class="font-medium text-green-700">تکمیل شده</span>
              <span class="text-sm font-medium text-green-600">{{ statistics.completedOrders }} سفارش</span>
            </div>
            <div class="flex items-center justify-between p-3 bg-yellow-50 rounded-lg">
              <span class="font-medium text-yellow-700">باز</span>
              <span class="text-sm font-medium text-yellow-600">{{ statistics.openOrders }} سفارش</span>
            </div>
            <div class="flex items-center justify-between p-3 bg-red-50 rounded-lg">
              <span class="font-medium text-red-700">لغو شده</span>
              <span class="text-sm font-medium text-red-600">{{ statistics.cancelledOrders }} سفارش</span>
            </div>
            <div class="flex items-center justify-between p-3 bg-orange-50 rounded-lg">
              <span class="font-medium text-orange-700">پرداخت نشده</span>
              <span class="text-sm font-medium text-orange-600">{{ statistics.unpaidOrders }} سفارش</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Pickup Delivery Statistics -->
      <div class="bg-white p-6 rounded-lg shadow-md mb-8">
        <h3 class="text-lg font-semibold text-gray-800 mb-4">آمار سفارشات تحویل</h3>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div class="text-center p-4 bg-blue-50 rounded-lg">
            <div class="text-2xl font-bold text-blue-600 mb-2">{{ statistics.pickupOrders }}</div>
            <div class="text-sm text-gray-600">کل سفارشات تحویل</div>
          </div>
          <div class="text-center p-4 bg-green-50 rounded-lg">
            <div class="text-2xl font-bold text-green-600 mb-2">{{ formatPrice(statistics.pickupRevenue) }}</div>
            <div class="text-sm text-gray-600">درآمد سفارشات تحویل</div>
          </div>
          <div class="text-center p-4 bg-purple-50 rounded-lg">
            <div class="text-2xl font-bold text-purple-600 mb-2">{{ formatPrice(statistics.totalDeliveryFees) }}</div>
            <div class="text-sm text-gray-600">مجموع هزینه‌های تحویل</div>
          </div>
        </div>
      </div>

      <!-- Pickup Orders with Delivery Addresses -->
      <div v-if="pickupOrdersWithAddress.length > 0" class="bg-white p-6 rounded-lg shadow-md mb-8">
        <h3 class="text-lg font-semibold text-gray-800 mb-4">سفارشات تحویل با آدرس</h3>
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">شماره سفارش</th>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">آدرس تحویل</th>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">هزینه تحویل</th>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">وضعیت</th>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">مبلغ کل</th>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">تاریخ</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr 
                v-for="order in pickupOrdersWithAddress" 
                :key="order.id"
                @click="openOrderDetails(order)"
                class="hover:bg-gray-50 cursor-pointer transition-colors group"
              >
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 group-hover:text-blue-600">#{{ order.id }}</td>
                <td class="px-6 py-4 text-sm text-gray-500 max-w-xs truncate">{{ order.deliveryAddress || 'آدرس ثبت نشده' }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ formatPrice(order.deliveryFee) }}</td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span
                    :class="[
                      'px-2 inline-flex text-xs leading-5 font-semibold rounded-full',
                      order.status === 0 ? 'bg-yellow-100 text-yellow-800' : '',
                      order.status === 1 ? 'bg-green-100 text-green-800' : '',
                      order.status === 2 ? 'bg-red-100 text-red-800' : '',
                      order.status === 3 ? 'bg-orange-100 text-orange-800' : ''
                    ]"
                  >
                    {{ getStatusText(order.status) }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ formatPrice(order.totalAmount) }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ formatDate(order.createdAt) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Internal Orders Statistics -->
      <div class="bg-white p-6 rounded-lg shadow-md mb-8">
        <h3 class="text-lg font-semibold text-gray-800 mb-4">آمار سفارشات داخلی</h3>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div class="text-center p-4 bg-purple-50 rounded-lg">
            <div class="text-2xl font-bold text-purple-600 mb-2">{{ statistics.internalOrders }}</div>
            <div class="text-sm text-gray-600">کل سفارشات داخلی</div>
          </div>
          <div class="text-center p-4 bg-green-50 rounded-lg">
            <div class="text-2xl font-bold text-green-600 mb-2">{{ formatPrice(statistics.internalRevenue) }}</div>
            <div class="text-sm text-gray-600">درآمد سفارشات داخلی</div>
          </div>
          <div class="text-center p-4 bg-orange-50 rounded-lg">
            <div class="text-2xl font-bold text-orange-600 mb-2">{{ internalOrdersWithEmployee.length }}</div>
            <div class="text-sm text-gray-600">سفارشات با کارمند مشخص</div>
          </div>
        </div>
      </div>

      <!-- Internal Orders with Employee Information -->
      <div v-if="internalOrdersWithEmployee.length > 0" class="bg-white p-6 rounded-lg shadow-md mb-8">
        <h3 class="text-lg font-semibold text-gray-800 mb-4">سفارشات داخلی با اطلاعات کارمند</h3>
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">شماره سفارش</th>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">کارمند</th>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">یادداشت</th>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">وضعیت</th>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">مبلغ کل</th>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">تاریخ</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr 
                v-for="order in internalOrdersWithEmployee" 
                :key="order.id"
                @click="openOrderDetails(order)"
                class="hover:bg-gray-50 cursor-pointer transition-colors group"
              >
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 group-hover:text-purple-600">#{{ order.id }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ order.employeeName || 'نامشخص' }}</td>
                <td class="px-6 py-4 text-sm text-gray-500 max-w-xs truncate">{{ order.notes || 'یادداشتی ثبت نشده' }}</td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span
                    :class="[
                      'px-2 inline-flex text-xs leading-5 font-semibold rounded-full',
                      order.status === 0 ? 'bg-yellow-100 text-yellow-800' : '',
                      order.status === 1 ? 'bg-green-100 text-green-800' : '',
                      order.status === 2 ? 'bg-red-100 text-red-800' : '',
                      order.status === 3 ? 'bg-orange-100 text-orange-800' : ''
                    ]"
                  >
                    {{ getStatusText(order.status) }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ formatPrice(order.totalAmount) }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ formatDate(order.createdAt) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Employee Statistics -->
      <div v-if="employeeStats.length > 0" class="bg-white p-6 rounded-lg shadow-md mb-8">
        <h3 class="text-lg font-semibold text-gray-800 mb-4">آمار سفارشات بر اساس کارمند</h3>
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">کارمند</th>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">تعداد سفارشات</th>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">مجموع مبلغ</th>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">سفارشات تکمیل شده</th>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">سفارشات پرداخت نشده</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr 
                v-for="employee in employeeStats" 
                :key="employee.employeeName"
                class="hover:bg-gray-50 transition-colors"
              >
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{{ employee.employeeName }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ employee.orderCount }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ formatPrice(employee.totalAmount) }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-green-600">{{ employee.completedOrders }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-orange-600">{{ employee.unpaidOrders }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Recent Orders Table -->
      <div class="bg-white rounded-lg shadow-md">
        <div class="p-6 border-b border-gray-200">
          <h3 class="text-lg font-semibold text-gray-800">سفارشات اخیر</h3>
        </div>
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">شماره سفارش</th>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">نوع سفارش</th>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">میز</th>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">بخش</th>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">وضعیت</th>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">مبلغ</th>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">تاریخ</th>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">روش پرداخت</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr 
                v-for="order in recentOrders" 
                :key="order.id"
                @click="openOrderDetails(order)"
                class="hover:bg-gray-50 cursor-pointer transition-colors group"
              >
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 group-hover:text-brown-600">#{{ order.id }}</td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span
                    :class="[
                      'px-2 inline-flex text-xs leading-5 font-semibold rounded-full',
                      order.isPickup ? 'bg-blue-100 text-blue-800' : '',
                      order.isInternalOrder ? 'bg-purple-100 text-purple-800' : '',
                      !order.isPickup && !order.isInternalOrder ? 'bg-gray-100 text-gray-800' : ''
                    ]"
                  >
                    {{ order.isPickup ? 'تحویل' : order.isInternalOrder ? 'داخلی' : 'میز' }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ order.tableName }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ order.sectionName }}</td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span
                    :class="[
                      'px-2 inline-flex text-xs leading-5 font-semibold rounded-full',
                      order.status === 0 ? 'bg-yellow-100 text-yellow-800' : '',
                      order.status === 1 ? 'bg-green-100 text-green-800' : '',
                      order.status === 2 ? 'bg-red-100 text-red-800' : '',
                      order.status === 3 ? 'bg-orange-100 text-orange-800' : ''
                    ]"
                  >
                    {{ getStatusText(order.status) }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ formatPrice(order.totalAmount) }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ formatDate(order.createdAt) }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ getPaymentMethodText(order.paymentMethod) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </main>

    <!-- Order Details Modal -->
    <OrderDetailsModal 
      v-if="showOrderDetailsModal"
      :order="selectedOrder"
      @close="closeOrderDetailsModal"
    />

    <!-- Persian Date Picker Modal -->
    <PersianDatePicker
      v-if="showDatePicker"
      :is-open="showDatePicker"
      :model-value="activeDatePicker === 'from' ? dateFrom : dateTo"
      @update:model-value="updateDate"
      @close="closeDatePicker"
    />
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import api from '@/services/api'
import OrderDetailsModal from './OrderDetailsModal.vue'
import PersianDatePicker from './PersianDatePicker.vue'
import moment from 'moment-jalaali'

export default {
  name: 'ReportsPage',
  components: {
    OrderDetailsModal,
    PersianDatePicker
  },
  setup() {
    const router = useRouter()
    const loading = ref(false)
    
    // Helper functions for Persian date conversion (moved up)
    const convertPersianToGregorian = (persianDate) => {
      if (!persianDate) return null
      try {
        const m = moment(persianDate, 'jYYYY/jMM/jDD')
        return m.isValid() ? m.format('YYYY-MM-DD') : null
      } catch (error) {
        console.error('Error converting Persian to Gregorian:', error)
        return null
      }
    }

    const convertGregorianToPersian = (gregorianDate) => {
      if (!gregorianDate) return null
      try {
        const m = moment(gregorianDate)
        return m.isValid() ? m.format('jYYYY/jMM/jDD') : null
      } catch (error) {
        console.error('Error converting Gregorian to Persian:', error)
        return null
      }
    }

    const getDefaultPersianDates = () => {
      try {
        const today = moment()
        const weekAgo = moment().subtract(7, 'days')
        return {
          from: weekAgo.format('jYYYY/jMM/jDD'),
          to: today.format('jYYYY/jMM/jDD')
        }
      } catch (error) {
        console.error('Error getting default Persian dates:', error)
        // Fallback to current date
        const today = moment()
        return {
          from: today.format('jYYYY/jMM/jDD'),
          to: today.format('jYYYY/jMM/jDD')
        }
      }
    }
    
    // Initialize with default Persian dates to avoid null values
    const defaultDates = getDefaultPersianDates()
    const dateFrom = ref(defaultDates.from)
    const dateTo = ref(defaultDates.to)
    

    
    const statistics = ref({
          totalOrders: 0,
          completedOrders: 0,
          cancelledOrders: 0,
          openOrders: 0,
          unpaidOrders: 0,
          totalRevenue: 0,
          pickupOrders: 0,
          pickupRevenue: 0,
          totalDeliveryFees: 0,
          internalOrders: 0,
          internalRevenue: 0
        })
    
    const sectionStats = ref([])
    const recentOrders = ref([])
    const pickupOrdersWithAddress = ref([])
    const internalOrdersWithEmployee = ref([])
    const employeeStats = ref([])
    const showOrderDetailsModal = ref(false)
    const selectedOrder = ref(null)
    const showDatePicker = ref(false)
    const activeDatePicker = ref('') // 'from' or 'to'
    const paymentMethodStats = ref({
      cash: 0,
      pos: 0,
      card: 0,
      mixed: 0,
      none: 0
    })

    const goToAdminPanel = () => {
      router.push('/admin')
    }

    const goToMenu = () => {
      router.push('/')
    }

    const openOrderDetails = (order) => {
      selectedOrder.value = order
      showOrderDetailsModal.value = true
    }

    const closeOrderDetailsModal = () => {
      showOrderDetailsModal.value = false
      selectedOrder.value = null
    }

    const formatPrice = (price) => {
      return new Intl.NumberFormat('fa-IR').format(price || 0) + ' تومان'
    }

    const formatDate = (dateString) => {
      if (!dateString) return ''
      const persianDate = convertGregorianToPersian(dateString)
      return persianDate || ''
    }

    const getStatusText = (status) => {
      switch (status) {
        case 0: return 'باز'
        case 1: return 'تکمیل شده'
        case 2: return 'لغو شده'
        case 3: return 'پرداخت نشده'
        default: return 'نامشخص'
      }
    }

    const getPaymentMethodText = (method) => {
      switch (method) {
        case 'cash': return 'نقد'
        case 'pos': return 'POS'
        case 'card': return 'کارت به کارت'
        case 'mixed': return 'ترکیبی'
        default: return 'بدون روش'
      }
    }

    const getOrderTypeText = (isPickup, isInternalOrder) => {
      if (isPickup) return 'تحویل'
      if (isInternalOrder) return 'داخلی'
      return 'میز'
    }

    const openDatePicker = (type) => {
      activeDatePicker.value = type
      showDatePicker.value = true
    }

    const closeDatePicker = () => {
      showDatePicker.value = false
      activeDatePicker.value = ''
    }

    const updateDate = (newDate) => {
      if (activeDatePicker.value === 'from') {
        dateFrom.value = newDate
      } else if (activeDatePicker.value === 'to') {
        dateTo.value = newDate
      }
    }



    const loadReports = async () => {
      try {
        console.log('loadReports called')
        loading.value = true

        // Ensure we have valid date values
        if (!dateFrom.value || !dateTo.value) {
          const defaultDates = getDefaultPersianDates()
          dateFrom.value = defaultDates.from
          dateTo.value = defaultDates.to
        }

        console.log('Date range:', { from: dateFrom.value, to: dateTo.value })

        // Convert Persian dates to Gregorian for API calls
        let gregorianDateFrom = convertPersianToGregorian(dateFrom.value)
        let gregorianDateTo = convertPersianToGregorian(dateTo.value)

        console.log('Gregorian dates:', { from: gregorianDateFrom, to: gregorianDateTo })

        // If conversion failed, use current date
        if (!gregorianDateFrom || !gregorianDateTo) {
          const today = moment().format('YYYY-MM-DD')
          const weekAgo = moment().subtract(7, 'days').format('YYYY-MM-DD')
          gregorianDateFrom = weekAgo
          gregorianDateTo = today
          console.log('Using fallback dates:', { from: gregorianDateFrom, to: gregorianDateTo })
        }

        // Load orders with date filter
        const ordersResponse = await api.get('/orders')
        const allOrders = ordersResponse.data
        
        console.log('All orders loaded:', allOrders.length)
        console.log('Sample order dates:', allOrders.slice(0, 3).map(o => ({
          id: o.id,
          createdAt: o.createdAt,
          dateOnly: new Date(o.createdAt).toISOString().split('T')[0],
          persianDate: convertGregorianToPersian(new Date(o.createdAt).toISOString().split('T')[0]),
          // Manual verification
          manualPersian: moment(new Date(o.createdAt).toISOString().split('T')[0]).format('jYYYY/jMM/jDD')
        })))

        // Filter orders by date range using Persian dates (more accurate for Persian calendar)
        const filteredOrders = allOrders.filter(order => {
          const orderDate = new Date(order.createdAt).toISOString().split('T')[0]
          const orderPersianDate = convertGregorianToPersian(orderDate)
          
          // Compare Persian dates directly
          const isInRange = orderPersianDate >= dateFrom.value && orderPersianDate <= dateTo.value
          
          console.log(`Order ${order.id}: Gregorian=${orderDate}, Persian=${orderPersianDate}, in range ${dateFrom.value}-${dateTo.value}? ${isInRange}`)
          return isInRange
        })
        
        console.log('Filtered orders count:', filteredOrders.length)
        
        // Show what date ranges would give 0 orders
        const allOrderPersianDates = allOrders.map(order => {
          const orderDate = new Date(order.createdAt).toISOString().split('T')[0]
          return convertGregorianToPersian(orderDate)
        })
        console.log('All order Persian dates:', allOrderPersianDates)
        console.log('To get 0 orders, select a date range that excludes these dates')

        // Calculate pickup delivery statistics
        const pickupOrders = filteredOrders.filter(o => o.isPickup)
        const completedPickupOrders = pickupOrders.filter(o => o.status === 1)
        
        // Calculate internal order statistics
        const internalOrders = filteredOrders.filter(o => o.isInternalOrder)
        const completedInternalOrders = internalOrders.filter(o => o.status === 1)
        
        // Calculate statistics
        statistics.value = {
          totalOrders: filteredOrders.length,
          completedOrders: filteredOrders.filter(o => o.status === 1).length,
          cancelledOrders: filteredOrders.filter(o => o.status === 2).length,
          openOrders: filteredOrders.filter(o => o.status === 0).length,
          unpaidOrders: filteredOrders.filter(o => o.status === 3).length,
          totalRevenue: filteredOrders
            .filter(o => o.status === 1) // Only completed orders count for revenue
            .reduce((sum, order) => sum + (order.totalAmount || 0), 0),
          pickupOrders: pickupOrders.length,
          pickupRevenue: completedPickupOrders
            .reduce((sum, order) => sum + (order.totalAmount || 0), 0),
          totalDeliveryFees: pickupOrders
            .reduce((sum, order) => sum + (order.deliveryFee || 0), 0),
          internalOrders: internalOrders.length,
          internalRevenue: completedInternalOrders
            .reduce((sum, order) => sum + (order.totalAmount || 0), 0)
        }

        // Calculate section statistics
        const sectionMap = new Map()
        filteredOrders.forEach(order => {
          const sectionName = order.sectionName
          if (!sectionMap.has(sectionName)) {
            sectionMap.set(sectionName, {
              sectionName,
              orderCount: 0,
              totalRevenue: 0
            })
          }
          const section = sectionMap.get(sectionName)
          section.orderCount++
          if (order.status === 1) { // Only completed orders count for revenue
            section.totalRevenue += order.totalAmount || 0
          }
        })
        sectionStats.value = Array.from(sectionMap.values())

        // Calculate payment method statistics
        const paymentMethodMap = new Map()
        filteredOrders.forEach(order => {
          const paymentMethod = order.paymentMethod || 'none'
          if (!paymentMethodMap.has(paymentMethod)) {
            paymentMethodMap.set(paymentMethod, 0)
          }
          paymentMethodMap.set(paymentMethod, paymentMethodMap.get(paymentMethod) + 1)
        })
        paymentMethodStats.value = {
          cash: paymentMethodMap.get('cash') || 0,
          pos: paymentMethodMap.get('pos') || 0,
          card: paymentMethodMap.get('card') || 0,
          mixed: paymentMethodMap.get('mixed') || 0,
          none: paymentMethodMap.get('none') || 0
        }

        // Get recent orders (last 10)
        recentOrders.value = filteredOrders
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          .slice(0, 10)

        // Get pickup orders with delivery addresses
        pickupOrdersWithAddress.value = pickupOrders
          .filter(order => order.deliveryAddress && order.deliveryAddress.trim() !== '')
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))

        // Get internal orders with employee information
        internalOrdersWithEmployee.value = internalOrders
          .filter(order => order.employeeName && order.employeeName.trim() !== '')
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))

        // Calculate employee statistics
        const employeeMap = new Map()
        internalOrders.forEach(order => {
          const employeeName = order.employeeName || 'نامشخص'
          if (!employeeMap.has(employeeName)) {
            employeeMap.set(employeeName, {
              employeeName,
              orderCount: 0,
              totalAmount: 0,
              completedOrders: 0,
              unpaidOrders: 0
            })
          }
          const employee = employeeMap.get(employeeName)
          employee.orderCount++
          employee.totalAmount += order.totalAmount || 0
          if (order.status === 1) {
            employee.completedOrders++
          } else if (order.status === 3) {
            employee.unpaidOrders++
          }
        })
        employeeStats.value = Array.from(employeeMap.values())

      } catch (error) {
        console.error('Error loading reports:', error)
        alert('خطا در بارگذاری گزارشات')
      } finally {
        loading.value = false
      }
    }

    // Watch for changes in date values to ensure they're always valid
    watch([dateFrom, dateTo], ([newDateFrom, newDateTo]) => {
      // Ensure dates are always valid Persian date strings
      if (!newDateFrom || typeof newDateFrom !== 'string') {
        dateFrom.value = moment().format('jYYYY/jMM/jDD')
      }
      if (!newDateTo || typeof newDateTo !== 'string') {
        dateTo.value = moment().format('jYYYY/jMM/jDD')
      }
    }, { immediate: true })

    onMounted(() => {
      loadReports()
    })

    return {
      loading,
      dateFrom,
      dateTo,
      statistics,
      sectionStats,
      recentOrders,
      pickupOrdersWithAddress,
      internalOrdersWithEmployee,
      employeeStats,
      showOrderDetailsModal,
      selectedOrder,
      showDatePicker,
      activeDatePicker,
      goToAdminPanel,
      goToMenu,
      openOrderDetails,
      closeOrderDetailsModal,
      formatPrice,
      formatDate,
      getStatusText,
      getPaymentMethodText,
      getOrderTypeText,
      openDatePicker,
      closeDatePicker,
      updateDate,
      loadReports,
      paymentMethodStats
    }
  }
}
</script>

<style scoped>
/* Styles for date inputs */
input[readonly] {
  background-color: #f9fafb;
  cursor: pointer;
}

input[readonly]:hover {
  background-color: #f3f4f6;
}
</style>
